import { render, staticRenderFns } from "./AddApplianceType.vue?vue&type=template&id=542f9614"
import script from "./AddApplianceType.vue?vue&type=script&lang=js"
export * from "./AddApplianceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports